import { render, staticRenderFns } from "./SO.vue?vue&type=template&id=01c4b81e"
import script from "./SO.vue?vue&type=script&lang=js"
export * from "./SO.vue?vue&type=script&lang=js"
import style0 from "./SO.vue?vue&type=style&index=0&id=01c4b81e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports